import { DataSheetsCard } from "@/services/backend/omni/datasheet/components/data-sheets-card";
import { useOmniBaseDataServiceKind } from "../use-omni-base-data-service-kind";

export function OmniDataSheetsBaseDataRoute() {
  const serviceKind = useOmniBaseDataServiceKind();

  return <DataSheetsCard serviceKind={serviceKind} />;
}
